
define('template!ordersDetailTrackingListHeaderToolsView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="add-region"></div>\n';

}
return __p
};});

